import React, { useState }         from "react"
import DashboardModal              from "./dashboard_modal"
import { deleteRequest, pathname } from '@helpers/javascript/javascript'

const EditDashboard = ({
  exportId,
  widgetTemplates = [],
  userCanSave,
  currentDashboard,
  setCurrentDashboard,
  setDashboards,
  setDashboardView,
  asDropdownItem = false
}) => {

  if (!currentDashboard) return
  
  const [isOpen,   setIsOpen]   = useState(false)

  const confirmSelection = (selected, name) => {
    setIsOpen(false)
    
    requestAnimationFrame(() => {
      setCurrentDashboard(prev => ({
        ...prev,
        widgets: selected,
        name
      }))
    })
  }

  const onDestroy = () => {
     if (!confirm(I18n.t("button.sure"))) return

    const path   = `/export_dashboards/${currentDashboard.id}`
    const params = {export: exportId}
    const format = 'json'
    const url = pathname({ path, format, params })
    deleteRequest(url).then(res => {
      setDashboards(res.dashboards)
      setDashboardView(false)
      const currentUrl = new URL(window.location.origin)
      currentUrl.pathname = `/exports/${exportId}`;
      window.history.pushState({}, '', currentUrl.toString())
      setIsOpen(false)
    })
  }

  const deleteButton =  <div className = "d-flex a-i-center p-absolute" style = {{left: '20px'}}>
                          <button
                            className = "btn btn-danger mr-2"
                            onClick   = {onDestroy}
                          >
                            <i className = "fa fa-trash" /> {I18n.t("export.destroy_button")}
                          </button>
                        </div>

  return (
    <>
      <button
        className = {asDropdownItem ? "dropdown-item" : "btn btn-primary small btn-sm mr-2 no-print"}
        onClick   = {() => setIsOpen(true)}
      >
        <i className = {`fa fa-pencil ${asDropdownItem ? "mr-2" : ""}`} /> {I18n.t("button.edit")}
      </button>

      <DashboardModal
        id               = {"edit-dashboard-modal"}
        widgetTemplates  = {widgetTemplates}
        isOpen           = {isOpen}
        setIsOpen        = {setIsOpen}
        onConfirm        = {confirmSelection}
        title            = {I18n.t('export.edit_dashboard')}
        dashboardTitle   = {currentDashboard?.name}
        selectedWidgets  = {currentDashboard?.widgets}
        extraButton      = {userCanSave && deleteButton}
        confirmText      = {I18n.t("button.view")}
      />
    </>
  )
}

export default EditDashboard